
import Vue from 'vue'
import { IHouse } from '@/types/houses'
import { IRequestsList } from '@/types/application'
import DispatcherPopup from '@/components/popup/DispatcherPopup.vue'
import FilterRequest from '@/components/request/FilterRequest.vue'
import ApplicationPopup from '@/components/popup/ApplicationPopup.vue'
import updateApplication from '@/connectors/application/update-application'
import { IStatus } from '@/types/parking'
import Loader from '@/components/Loader.vue'
import { tableFields } from '@/services'
import { ModalIds } from '@/components/popup/modal-ids'
import { Endpoints } from '@/connectors/endpoints'
import Dispatcher from '@/pages/app/Dispatcher.vue'

export default Vue.extend({
  name: 'RequestContractor',
  components: {
    ApplicationPopup,
    DispatcherPopup,
    Loader,
    FilterRequest
  },
  extends: Dispatcher,
  data () {
    return {
      ModalIds,
      Endpoints,
      loader: false,
      errorMessage: '',
      editing: false,
      statusList: {} as IStatus,
      selectedHouse: {} as IHouse,
      houses: [] as IHouse[],
      fields: tableFields.DISPATCHER,
      applicationList: [] as IRequestsList[],
      filteredList: [] as IRequestsList[],
      application: {} as IRequestsList,
      isDisabled: false,
      EndpointsGetApplication: Endpoints.GET_CONTRACTOR_APPLICATIONS_LIST,
      filterAddress: '',
      filterType: {
        allHouses: 0,
        onlyActivity: 0,
        date: 0,
        unAssigned: 0
      }
    }
  },
  computed: {
    idSelectedOrganization (): number {
      return this.$store.state.profile.currentOrganization.id
    },
    filteredPayments (): any {
      if (this.filterAddress) {
        return this.applicationList.filter(item => item.personalAccount.houseShortAddress.toLowerCase().includes(this.filterAddress.toLowerCase()))
      }
      return this.applicationList
    }
  },
  watch: {
    idSelectedOrganization () {
      if (this.idSelectedOrganization) {
        // @ts-ignore
        this.getApplicationsStatuses()
      }
    }
  },
  methods: {
    // Обновление заявки
    updateApplication (value) {
      const formData = {
        cid: this.idSelectedOrganization,
        contractor_user_id: value.managingOrganizationUser.id,
        quantity: value.quantity,
        status: value.status.status,
        id: this.application.id,
        agreedTime: value.agreedTime
      }
      this.isDisabled = true
      updateApplication(formData, Endpoints.UPDATE_CONTRACTOR_APPLICATION)
        .then(() => {
          // @ts-ignore
          this.getApplicationsList()
          // @ts-ignore
          this.$showSuccessToast('Заявка обновлена успешно')
          this.isDisabled = false
          this.$bvModal.hide(ModalIds.APPLICATION_POPUP)
        }).catch(e => {
          this.isDisabled = false
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    }
  }
})
